import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import useFetch from "shared/model/useFetch";
import useAlertModalAtom from "shared/model/useAlertModalAtom";
import {
  OFFICIAL,
  PRELIMINARY,
  STORE,
  TRYOUT,
  FREEROLL,
} from "shared/constant/lookup/eventType";
import { datetimeLocalCalculator } from "shared/lib/datetimeLocalCalculator";

const usePostEvent = (
  nameRef,
  eventTypeFlag,
  addressRef,
  dateRef,
  regDateRef,
  requiredProGradeFlag,
  contentRef,
  imgPathList,
  posterFilePath,
  sereisIdx,
  startingChipRef,
  regEndLevelRef,
  earlyEndLevelRef,
  earlyChipRef,
  maxEntryRef,
  reEntryRef,
  reEntryChipList,
  addOnRef,
  addOnChipRef,
  prizeTotalRef,
  seedTicketTypeIdx,
  ticketNumberRef,
  publishedTicketNumberRef,
  prizeList,
  durationList,
  manager_idx
) => {
  const navigate = useNavigate();

  const [fetchResult, fetchRequest] = useFetch();
  const [, setAlert] = useAlertModalAtom();

  const clickEvent = () => {
    if (reEntryChipList.some((item) => item === null || item === "")) {
      setAlert("리엔트리 칩 입력 양식을 확인해 주세요.");
      return;
    }

    // 듀레이션 전처리 ( level 삽입 및 empty 제거 )
    const newDurationList = [...durationList];
    let level = 0;
    newDurationList.forEach((elem, index) => {
      const tmp = [...elem];
      if (tmp[0] === null) {
        level += 1;
        tmp[0] = level;
      }
      if (tmp[2] === "empty") {
        tmp[2] = null;
        tmp[3] = null;
        tmp[4] = null;
      }
      newDurationList[index] = tmp;
    });

    const obj = {
      name: nameRef?.current?.value,
      event_type_flag: eventTypeFlag,
      reg_date: datetimeLocalCalculator(regDateRef?.current?.value),
      date: datetimeLocalCalculator(dateRef?.current?.value),
      required_pro_grade_flag: requiredProGradeFlag,
      content: contentRef?.current?.value,
      starting_chip: startingChipRef?.current?.value,
      prize_list: JSON.stringify(prizeList),
      duration_list: JSON.stringify(newDurationList),
    };
    if (imgPathList.length > 0) obj["img_list"] = imgPathList;
    if (posterFilePath) obj["poster_img"] = posterFilePath;
    if (regEndLevelRef?.current?.value)
      obj["reg_end_level"] = regEndLevelRef?.current?.value;
    if (maxEntryRef?.current?.value)
      obj["max_entry"] = maxEntryRef?.current?.value;
    if (reEntryRef?.current?.value)
      obj["re_entry"] = reEntryRef?.current?.value;
    if (reEntryChipList) obj["re_entry_chip"] = reEntryChipList;
    if (earlyEndLevelRef?.current?.value)
      obj["early_end_level"] = earlyEndLevelRef?.current?.value;
    if (earlyChipRef?.current?.value)
      obj["early_chip"] = earlyChipRef?.current?.value;
    if (addOnRef?.current?.value) obj["add_on"] = addOnRef?.current?.value;
    if (addOnChipRef?.current?.value)
      obj["add_on_chip"] = addOnChipRef?.current?.value;
    if (prizeTotalRef?.current?.value)
      obj["prize_total"] = prizeTotalRef?.current?.value;

    if (eventTypeFlag === OFFICIAL) {
      obj["address"] = addressRef?.current?.value;
      obj["series_idx"] = sereisIdx;
      obj["ticket_number"] = ticketNumberRef?.current?.value;
      obj["seed_ticket_type_idx"] = seedTicketTypeIdx;
    } else if (eventTypeFlag === PRELIMINARY) {
      obj["series_idx"] = sereisIdx;
      obj["ticket_number"] = ticketNumberRef?.current?.value;
    } else if (eventTypeFlag === STORE) {
      obj["ticket_number"] = ticketNumberRef?.current?.value;
    } else if (eventTypeFlag === TRYOUT) {
      obj["address"] = addressRef?.current?.value;
    } else if (eventTypeFlag === FREEROLL) {
      obj["address"] = addressRef?.current?.value;
      obj["published_ticket_number"] = publishedTicketNumberRef?.current.value;
    }

    if (manager_idx) obj["manager_idx"] = manager_idx;

    fetchRequest("POST", "/admin/event", obj);
  };

  useEffect(() => {
    switch (fetchResult?.statusCode) {
      case 200:
        navigate(-1);
        break;
      case 400:
        if (fetchResult?.data?.error_code === "name")
          setAlert("대회 이름 입력 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "event_type_flag")
          setAlert("대회 종류 입력 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "reg_ date")
          setAlert("접수 시간 입력 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "date")
          setAlert("대회 시간 입력 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "required_pro_grade_flag")
          setAlert("요구 프로 자격 입력 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "content")
          setAlert("본문 입력 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "starting_chip")
          setAlert("스타팅 칩 입력 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "prize_list")
          setAlert("프라이즈 목록 입력 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "duration_list")
          setAlert("듀레이션 목록 입력 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "img_list")
          setAlert("첨부 이미지 목록 입력 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "reg_end_level")
          setAlert("레지 마감 레벨 입력 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "max_entry")
          setAlert("최대 엔트리 입력 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "re_entry")
          setAlert("리엔트리 횟수 제한 입력 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "re_entry_chip")
          setAlert("리엔트리 추가 칩 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "early_end_level")
          setAlert("얼리 마감 레벨 입력 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "early_chip")
          setAlert("얼리 추가 칩 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "add_on")
          setAlert("에드온 입력 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "add_on_chip")
          setAlert("에드온 추가 칩 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "prize_totle")
          setAlert("총 프라이즈 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "address")
          setAlert("대회 주소지 입력 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "series_idx")
          setAlert("대회 시리즈 입력 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "ticket_number")
          setAlert("참가 재료 개수 입력 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "seed_ticket_type_idx")
          setAlert("참가 시드권 종류 입력 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "published_ticket_number")
          setAlert("참가권 발행 개수 입력 양식을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "manager_idx")
          setAlert("매장 입력 필드를 확인해 주세요.");
        else setAlert("입력한 값의 형식이 잘못되었습니다.");
        break;
      case 403:
        if (fetchResult?.data?.error_code === 1)
          setAlert("선택한 대회 종류에 대한 접근 권한이 없습니다.");
        break;
      case 404:
        if (fetchResult?.data?.error_code === 1)
          setAlert("프로 자격 데이터가 존재하지 않습니다.");
        else if (fetchResult?.data?.error_code === 2)
          setAlert("대회 종류 데이터가 존재하지 않습니다.");
        else if (fetchResult?.data?.error_code === 3)
          setAlert("대회 시리즈 데이터가 존재하지 않습니다.");
        else if (fetchResult?.data?.error_code === 4)
          setAlert("시드권 종류 데이터가 존재하지 않습니다.");
        else if (fetchResult?.data?.error_code === 5)
          setAlert("시즌 정보가 존재하지 않습니다.");

        break;
      default:
        break;
    }
  }, [fetchResult]);

  return [clickEvent];
};

export default usePostEvent;
